import isEmpty from 'lodash/isEmpty';
import uuid from 'uuid';

export const newCampaignForm = () => {
  return {
    campaignId: uuid.v4(),
    isValid: false,
    content: {
      name: '',
      id: '',
    },
    segment: {
      segmentId: '',
      segmentName: '',
    },
    platform: {
      channel: '',
    },
    schedule: {
      endTime: '',
      frequency: '',
      startTime: '',
      timeZone: '',
    },
  };
};

export const validateContentInput = ({ name, id }) => {
  return !isEmpty(name) && !isEmpty(id);
};

export const validateSegmentInput = ({ segmentId, segmentName }) => {
  return !isEmpty(segmentId) && !isEmpty(segmentName);
};

export const validateChannelInput = ({ channel }) => {
  return !isEmpty(channel);
};

export const validateScheduleInput = ({ endTime, frequency, startTime, timeZone, fromAddress }) => {
  return (
    !isEmpty(endTime) &&
    !isEmpty(frequency) &&
    !isEmpty(startTime) &&
    !isEmpty(timeZone) &&
    !isEmpty(fromAddress)
  );
};

export const validateCampaignFormData = campaign => {
  const { content, segment, platform, schedule } = campaign;
  return (
    validateContentInput(content) &&
    validateSegmentInput(segment) &&
    validateChannelInput(platform) &&
    validateScheduleInput(schedule)
  );
};

export const validateAllCampaignsInput = (campaigns = []) => {
  if (isEmpty(campaigns)) {
    return false;
  }
  return !campaigns.some(cmp => !cmp.isValid);
};
export const buildCreateMultiCampaignPayload = (formData, userInfo) => {
  const { journeyName, journeyDescription, campaigns } = formData;
  const payload = {
    userGroupName: userInfo?.selectedAccessGroupName,
    userName: userInfo.user,
    campaigns: campaigns?.reduce((acc, { content, schedule, segment, platform }) => {
      const data = {
        campaignIdentifier: {
          campaignName: journeyName,
          campaignDescription: journeyDescription,
        },
        channel: platform.channel,
        createdBy: userInfo.user,
        endTime: schedule.endTime,
        frequency: schedule.frequency,
        lastUpdatedBy: userInfo.user,
        messageTemplateName: content.name,
        fromAddress: schedule.fromAddress,
        segmentIdentifier: {
          segmentId: segment.segmentId,
          segmentName: segment.segmentName,
        },
        startTime: schedule.startTime,
        timeZone: schedule.timeZone,
      };
      acc.push(data);
      return acc;
    }, []),
  };

  return payload;
};

export const accessById = option => option.id;

export const accessByValue = option => option.value;
